import {Component, OnInit} from '@angular/core';
import {SchedulingReportService} from '../services/scheduling-report.service';
import {UserService} from '../services/user.service';
import {Message} from 'primeng/primeng';
import {ConfirmationService} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';
import {AlarmTypeService} from '../services/alarm-type.service';

@Component({
    selector: 'app-scheduling-report',
    templateUrl: './scheduling-report.component.html',
    styleUrls: ['./scheduling-report.component.css'],
    providers: [ConfirmationService]
})
export class SchedulingReportComponent implements OnInit {

    msgs: Message[] = [];
    messages: Message[] = [];
    schedulingReport: any;
    schedulingReports: any [];
    reports: SelectItem[];
    frequencies: SelectItem[];
    displayAdd: boolean = false;
    displayEdit: boolean = false;
    blockedDocument: boolean = false;
    showFilter: boolean = false;
    showColumnCreatedBy = false;
    emails: string[];
    emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    alarmTypes: SelectItem[];
    groupsBy: SelectItem[];

    constructor(private schedulingReportService: SchedulingReportService, private userService: UserService,
                private confirmationService: ConfirmationService, private alarmTypeService: AlarmTypeService
    ) {
    }

    ngOnInit() {
        this.alarmTypes = [{label: 'Todos', value: null}];
        this.groupsBy = [
            {label: 'Ninguno', value: ''},
            {label: 'Dia', value: 'D'},
            {label: 'Semana', value: 'W'}
        ];
        this.alarmTypeService.findByStatus('H').then(data => {
            let response: any = data;
            response.alarmTypes.forEach(item => {
                this.alarmTypes.push({label: item.description, value: item.idAlarmType});
            });
        }).catch(err => {
            console.log(err);
            this.msgs = [{
                severity: 'error',
                summary: 'ERROR',
                detail: 'Existe algun problema con la conexión al servidor'
            }];
        });
        this.showColumnCreatedBy = this.userService.userLoged.idProfile == 1;
        this.init();
        /*this.reports = [{label: "Reporte GPS", value: 1},
        {label: "Reporte de Viajes", value: 2},
        {label: "Tiempos Estacionados", value: 3},
        {label: "Distancias Recorridas", value: 4},
        {label: "Consumo Combustible", value: 5},
        {label: "Exceso de Velocidad", value: 6},
        {label: "Reporte de Ocio", value: 7},
        {label: "Reporte de Estado", value: 8},
        {label: "Reporte de Alarmas", value: 9},
        {label: "Fuera de Horario", value: 10}];*/

        this.reports = [
            {label: 'Alarmas', value: 4},
            {label: 'Distancia Recorrida', value: 8},
            {label: 'Exceso de velocidad', value: 3},
            {label: 'Estados', value: 6},
            {label: 'Fuera de Horario', value: 2},
            {label: 'Infracciones', value: 7},
            {label: 'Tiempos Estacionados', value: 5},
            {label: 'Viajes', value: 1}
        ];
        this.frequencies = [
            /*{label: "Diario", value: 1},*/
            {label: 'Semanal', value: 2},
            {label: 'Dias de la Semana', value: 3},
            {label: 'Mensual', value: 4}];
    }

    init() {
        this.schedulingReports = [];
        this.schedulingReportService.findByUser(this.userService.userLoged.idUser).then(data => {
            let response: any = data;
            response.schedulingReports.forEach(item => {
                this.schedulingReports.push(item);
            });
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
        });
        this.hide();
    }

    validateEmails(): boolean {
        let emailsValidos = true;
        if (this.emails.length > 2) {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Solo puede introducir 2 cuentas de correo'}];
            return false;
        }
        this.emails.forEach(item => {
            if (item != null && item != '' && !this.emailRegex.test(item)) {
                emailsValidos = false;
            }
        });
        if (!emailsValidos) {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: 'Formato de email no válido'}];
            return false;
        }
        return true;
    }

    showAdd() {
        this.displayAdd = true;
    }

    showEdit(schedulingReport: any) {
        this.schedulingReport = {...schedulingReport};
        console.log(this.schedulingReport);
        this.displayEdit = true;
        this.emails = this.schedulingReport.email.split(';');
        this.reportSelected();
    }

    hide() {
        this.schedulingReport = {idUser: this.userService.userLoged.idUser};
        this.emails = [];
        this.displayAdd = false;
        this.displayEdit = false;
    }

    add() {
        if (!this.validateEmails()) {
            return;
        }
        this.blockedDocument = true;
        this.schedulingReport.email = '';
        this.emails.forEach(item => {
            this.schedulingReport.email += item + ';'
        });
        this.schedulingReport.email = this.schedulingReport.email.substring(0, this.schedulingReport.email.length - 1)

        this.schedulingReportService.create(this.schedulingReport).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.init();
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Registro insertado exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
            this.blockedDocument = false;
        });
    }

    edit() {
        if (!this.validateEmails()) {
            return;
        }
        this.blockedDocument = true;
        this.schedulingReport.email = '';
        this.emails.forEach(item => {
            this.schedulingReport.email += item + ';'
        });
        this.schedulingReport.email = this.schedulingReport.email.substring(0, this.schedulingReport.email.length - 1)

        this.schedulingReportService.edit(this.schedulingReport).then(data => {
            let response: any = data;
            if (response.status == 'OK') {
                this.init();
                this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Registro modificado exitosamente'}];
            } else {
                this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
            }
            this.blockedDocument = false;
        }).catch(err => {
            this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
            this.blockedDocument = false;
        });
    }

    del(idUser: String, idSchedule: String) {
        this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.schedulingReportService.remove(idUser, idSchedule).then(data => {
                    let response: any = data;
                    if (response.status == 'OK') {
                        this.init();
                        this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Registro eliminado exitosamente'}];
                    } else {
                        this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err => {
                    this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
                    this.blockedDocument = false;
                });
            }
        });
    }

    resend(schedulingReport: any) {
        this.confirmationService.confirm({
            message: 'Esta seguro de reenviar el reporte programado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.schedulingReportService.resend(schedulingReport).then(data => {
                    let response: any = data;
                    if (response.status == 'OK') {
                        this.msgs = [{severity: 'info', summary: 'INFO', detail: 'Informe enviado exitosamente'}];
                    } else {
                        this.msgs = [{severity: 'error', summary: 'ERROR', detail: response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err => {
                    this.msgs = [{severity: 'error', summary: 'ERROR', detail: err}];
                    this.blockedDocument = false;
                });
            }
        });
    }

    changeFrecuency(event) {
        if (event.value == 1) {
            this.messages = [{
                severity: 'info',
                summary: 'INFO',
                detail: 'Reporte automático del día anterior a enviarse todos los días'
            }];
        } else if (event.value == 2) {
            this.messages = [{
                severity: 'info',
                summary: 'INFO',
                detail: 'Reporte automático de la semana anterior enviado cada dia Lunes'
            }];
        } else if (event.value == 3) {
            this.messages = [{
                severity: 'info',
                summary: 'INFO',
                detail: 'Reporte automático de dias de la semana anterior enviado cada dia Lunes'
            }];
        } else if (event.value == 4) {
            this.messages = [{
                severity: 'info',
                summary: 'INFO',
                detail: 'Reporte automático del mes anterior enviado cada 1ero'
            }];
        }
    }

    reportSelected() {
        if (this.schedulingReport.report == 3 || this.schedulingReport.report == 4 ||
            this.schedulingReport.report == 5 || this.schedulingReport.report == 6 || this.schedulingReport.report == 8) {
            this.showFilter = true;
            if (this.schedulingReport.report == 3) {
                if (!this.schedulingReport.filter) {
                    this.schedulingReport.filter = 60;
                }
            } else if (this.schedulingReport.report == 5 || this.schedulingReport.report == 6) {
                if (!this.schedulingReport.filter) {
                    this.schedulingReport.filter = 5;
                }
            } else if (this.schedulingReport.report == 8) {
                if (!this.schedulingReport.filter) {
                    this.schedulingReport.filter = 'D';
                }
            }
        } else {
            this.showFilter = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/scheduling-report/scheduling-report.component.ts